var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-wizard-overview-scenario" }, [
    _vm.triggerItem
      ? _c(
          "div",
          { staticClass: "automation-wizard-overview-scenario__trigger" },
          [
            _c("CompassColoredIcon", {
              staticClass: "automation-wizard-overview-scenario__trigger-icon",
              attrs: { icon: "flash", color: "teal", size: "large" }
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "automation-wizard-overview-scenario__trigger-label typographies-paragraph-medium-semibold"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.triggerItem.label) +
                    "\n        "
                )
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.triggerItem && _vm.actionItems.length > 0
      ? _c(
          "div",
          { staticClass: "automation-wizard-overview-scenario__separator" },
          [
            _c("CompassIcon", {
              staticClass:
                "automation-wizard-overview-scenario__separator-icon",
              attrs: { icon: "arrow-down" }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.actionItems.length > 0
      ? _c(
          "div",
          { staticClass: "automation-wizard-overview-scenario__actions" },
          _vm._l(_vm.actionItems, function(action, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "automation-wizard-overview-scenario__action"
              },
              [
                _c("CompassColoredIcon", {
                  staticClass:
                    "automation-wizard-overview-scenario__action-icon",
                  attrs: { icon: "target", color: "coral", size: "large" }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "automation-wizard-overview-scenario__action-label typographies-paragraph-medium-semibold"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(action.label) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }